// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

// import third-party libraries
import Scrollchor from 'react-scrollchor';
import _ from 'lodash';
import classNames from 'classnames';

// import contentModule css modules
import contentModuleStyles from '../contentModuleModuleStyles.css';

import NextNode from '../../node/components/NextNode.js.jsx';

const ContentModuleNodeNav = ({
  currentNode
  , currentScene
  , match
  , nodes
  , previouslyViewedNodeIds
  , onNodeClick
  , replayVideo
  , reviewPDF
  , scenes
  , contentModule
  , visible
}) => {
  let menuClass = classNames(
    'next-menu yt-row'
    , { '-visible': visible }
    , { '-white-bg' : !currentScene.transparentOverlay }
  )
  let followupClass = classNames(
    '-follow-ups yt-col full s_50'
    , { '-no-poster': !currentScene.posterUrl }
  )

  // const hasChart = true;
  const hasChart = currentScene && currentScene.chart && currentScene.chart.blocks && currentScene.chart.blocks.length > 0
  return (

    <div className={menuClass}>
      <div className="-overlay-text-wrapper yt-col full s_50">
        { currentScene && currentScene.overlayText ?
            <div className="-overlay-text">
              <h3><b>{currentScene.overlayText}</b></h3>
            </div>
          :
          null
        }
        <div className="-button-wrapper yt-row center">
          <Scrollchor to="#resources" className="yt-btn x-small -trailer-btn">Scroll to {hasChart ? <span>chart & </span> : null} resources <i className="-icon fas fa-arrow-circle-down"/></Scrollchor>
          { currentScene.videoPath ?
            <span className="yt-btn x-small -trailer-btn" onClick={() => replayVideo()}><i className="-icon fas fa-play-circle"/> Replay video</span>
            :
            currentScene.pdfPath ?
            <span className="yt-btn x-small -trailer-btn" onClick={() => reviewPDF()}><i className="-icon fas fa-play-circle"/> Review document</span>
            :
            null
          }
        </div>
      </div>
      <div className={followupClass}>
        <div className="-qa-wrapper">
          { currentScene && currentScene.followupQuestion ?
            <div className="-question">{currentScene.followupQuestion}</div>
            :
            <div className="-question">Please make your selection from the action button(s) below.</div>
          }
          <ul className="-nodes">
            { nodes && scenes && nodes.length > 0 && scenes.length > 0 ?
              nodes.map((node, i) =>
                <NextNode
                  key={node._id + i}
                  node={node}
                  onNodeClick={onNodeClick}
                  scene={_.find(scenes, scene => scene._id === node._scene)}
                  viewedNodes={previouslyViewedNodeIds}
                />
              )
              :
              currentNode && !currentNode.exit ?
                <span>*ALERT*: An error occurred while finding follow ups. Please try refreshing your page. If the problems persist, please contact support.</span>
              :
              null
            }
            { currentNode.exit ?
              <li>
                <Link className="node-link" to={`${match.url.replace(`/node/${match.params.nodeId}`, '/conclusion')}`}>Continue <i className="far fa-lg fa-arrow-from-left"/></Link>
              </li>
              :
              null
            }
          </ul>
        </div>
      </div>
    </div>
  )
}

ContentModuleNodeNav.propTypes = {
  currentNode: PropTypes.object.isRequired
  , currentScene: PropTypes.object
  , match: PropTypes.object.isRequired
  , nodes: PropTypes.array
  , previouslyViewedNodeIds: PropTypes.array
  , onNodeClick: PropTypes.func.isRequired
  , replayVideo: PropTypes.func.isRequired
  , scenes: PropTypes.array
  , contentModule: PropTypes.object.isRequired
  , visible: PropTypes.bool
}

ContentModuleNodeNav.defaultProps = {
  currentScene: null
  , nodes: []
  , scenes: []
  , visible: false
}

export default withRouter(ContentModuleNodeNav);



// WEBPACK FOOTER //
// modules/contentModule/components/ContentModuleNodeNav.js.jsx